import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8230d074"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-150 mb-x1" }
const _hoisted_2 = { class: "w-80 mb-x1" }
const _hoisted_3 = { class: "w-100 mb-x3" }
const _hoisted_4 = { class: "variant-grid" }

import SkeletonLine from '@/shared/spinners/SkeletonLine.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SkeletonLine, { class: "h-20" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SkeletonLine)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SkeletonLine)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4], (skeleton) => {
        return _createElementVNode("div", {
          key: skeleton,
          class: "w-100"
        }, [
          _createVNode(SkeletonLine, { class: "h-75" })
        ])
      }), 64))
    ])
  ]))
}
}

})